/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Premium_Pool_UnlimitedInputs */

const en_model_premium_pool_unlimited = /** @type {(inputs: Model_Premium_Pool_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium credits: unlimited`)
};

const id_model_premium_pool_unlimited = /** @type {(inputs: Model_Premium_Pool_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredit premium: tanpa batas`)
};

/**
* | output |
* | --- |
* | "Premium credits: unlimited" |
*
* @param {Model_Premium_Pool_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_premium_pool_unlimited = /** @type {((inputs?: Model_Premium_Pool_UnlimitedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Premium_Pool_UnlimitedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_premium_pool_unlimited(inputs)
	return en_model_premium_pool_unlimited(inputs)
});